/**
 * LitterLove Shopify Theme - JavaScript
 * Converted from React to vanilla JavaScript
 */

(function() {
  'use strict';

  // ============================================
  // 1. CART DRAWER FUNCTIONALITY
  // ============================================
  const CartDrawer = {
    overlay: null,
    drawer: null,
    itemsContainer: null,
    totalPrice: null,
    itemCount: null,
    checkoutButton: null,

    init() {
      this.overlay = document.querySelector('.cart-drawer-overlay');
      this.drawer = document.querySelector('.cart-drawer');
      this.itemsContainer = document.querySelector('.cart-drawer-items');
      this.totalPrice = document.querySelector('.cart-drawer-total-price');
      this.itemCount = document.querySelector('.cart-badge');
      this.checkoutButton = document.querySelector('.cart-drawer-checkout');

      // Bind events
      document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
        btn.addEventListener('click', () => this.toggle());
      });

      document.querySelector('.cart-drawer-close')?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());

      // Escape key closes drawer
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) this.close();
      });
    },

    isOpen() {
      return this.drawer?.classList.contains('open');
    },

    toggle() {
      this.isOpen() ? this.close() : this.open();
    },

    open() {
      this.overlay?.classList.add('open');
      this.drawer?.classList.add('open');
      document.body.style.overflow = 'hidden';
      this.fetchCart();
    },

    close() {
      this.overlay?.classList.remove('open');
      this.drawer?.classList.remove('open');
      document.body.style.overflow = '';
    },

    async fetchCart() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        this.render(cart);
      } catch (error) {
        console.error('Error fetching cart:', error);
      }
    },

    render(cart) {
      if (!this.itemsContainer) return;

      if (cart.item_count === 0) {
        this.itemsContainer.innerHTML = `
          <div class="cart-drawer-empty">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/>
              <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
            </svg>
            <p>Your cart is empty</p>
          </div>
        `;
      } else {
        this.itemsContainer.innerHTML = cart.items.map(item => `
          <div class="cart-item" data-key="${item.key}">
            <div class="cart-item-image">
              <img src="${item.image || '/placeholder.svg'}" alt="${item.title}">
            </div>
            <div class="cart-item-details">
              <h4 class="cart-item-title">${item.product_title}</h4>
              <p class="cart-item-variant">${item.variant_title || ''}</p>
              <p class="cart-item-price">${this.formatMoney(item.final_line_price)}</p>
            </div>
            <div class="cart-item-actions">
              <button class="btn-icon-sm cart-item-remove" data-key="${item.key}" aria-label="Remove item">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                  <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                </svg>
              </button>
              <div class="cart-item-quantity">
                <button class="btn btn-outline btn-icon-sm" data-quantity-minus data-key="${item.key}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14"/>
                  </svg>
                </button>
                <span>${item.quantity}</span>
                <button class="btn btn-outline btn-icon-sm" data-quantity-plus data-key="${item.key}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14"/><path d="M12 5v14"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        `).join('');

        // Bind item events
        this.bindItemEvents();
      }

      // Update totals
      if (this.totalPrice) {
        this.totalPrice.textContent = this.formatMoney(cart.total_price);
      }
      if (this.itemCount) {
        this.itemCount.textContent = cart.item_count;
        this.itemCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    },

    bindItemEvents() {
      // Remove item buttons
      this.itemsContainer.querySelectorAll('.cart-item-remove').forEach(btn => {
        btn.addEventListener('click', () => this.updateItem(btn.dataset.key, 0));
      });

      // Quantity minus buttons
      this.itemsContainer.querySelectorAll('[data-quantity-minus]').forEach(btn => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.cart-item');
          const currentQty = parseInt(item.querySelector('.cart-item-quantity span').textContent);
          this.updateItem(btn.dataset.key, currentQty - 1);
        });
      });

      // Quantity plus buttons
      this.itemsContainer.querySelectorAll('[data-quantity-plus]').forEach(btn => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.cart-item');
          const currentQty = parseInt(item.querySelector('.cart-item-quantity span').textContent);
          this.updateItem(btn.dataset.key, currentQty + 1);
        });
      });
    },

    async updateItem(key, quantity) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        const cart = await response.json();
        this.render(cart);
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    },

    async addItem(variantId, quantity = 1) {
      try {
        this.checkoutButton?.classList.add('loading');
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        });
        
        if (!response.ok) throw new Error('Failed to add item');
        
        await this.fetchCart();
        this.open();
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        this.checkoutButton?.classList.remove('loading');
      }
    },

    formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  };

  // ============================================
  // 2. PRODUCT VARIANT SELECTOR
  // ============================================
  const ProductVariants = {
    form: null,
    variantSelect: null,
    priceElement: null,
    addButton: null,
    availabilityElement: null,
    variants: [],

    init() {
      this.form = document.querySelector('.product-form');
      if (!this.form) return;

      this.variantSelect = this.form.querySelector('[name="id"]');
      this.priceElement = document.querySelector('.product-price');
      this.addButton = this.form.querySelector('.product-add-button');
      this.availabilityElement = document.querySelector('.product-availability');

      // Get variants from JSON script
      const variantsScript = document.querySelector('[data-product-variants]');
      if (variantsScript) {
        try {
          this.variants = JSON.parse(variantsScript.textContent);
        } catch (e) {
          console.error('Error parsing variants:', e);
        }
      }

      // Bind option buttons
      this.form.querySelectorAll('.product-option-button').forEach(btn => {
        btn.addEventListener('click', (e) => this.handleOptionClick(e));
      });

      // Form submission
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    },

    handleOptionClick(e) {
      const btn = e.target.closest('.product-option-button');
      const optionGroup = btn.closest('.product-option');
      const optionName = optionGroup.dataset.optionName;
      const optionValue = btn.dataset.optionValue;

      // Update selected state
      optionGroup.querySelectorAll('.product-option-button').forEach(b => {
        b.classList.remove('selected');
      });
      btn.classList.add('selected');

      // Find matching variant
      this.updateSelectedVariant();
    },

    updateSelectedVariant() {
      const selectedOptions = {};
      this.form.querySelectorAll('.product-option').forEach(group => {
        const selected = group.querySelector('.product-option-button.selected');
        if (selected) {
          selectedOptions[group.dataset.optionName] = selected.dataset.optionValue;
        }
      });

      // Find variant matching all selected options
      const matchingVariant = this.variants.find(variant => {
        return variant.options.every((opt, i) => {
          const optionName = `option${i + 1}`;
          return !selectedOptions[optionName] || selectedOptions[optionName] === opt;
        });
      });

      if (matchingVariant) {
        this.variantSelect.value = matchingVariant.id;
        this.updateUI(matchingVariant);
      }
    },

    updateUI(variant) {
      // Update price
      if (this.priceElement) {
        this.priceElement.textContent = '$' + (variant.price / 100).toFixed(2);
      }

      // Update availability
      if (this.availabilityElement) {
        if (variant.available) {
          this.availabilityElement.textContent = 'In Stock';
          this.availabilityElement.classList.remove('out-of-stock');
        } else {
          this.availabilityElement.textContent = 'Out of Stock';
          this.availabilityElement.classList.add('out-of-stock');
        }
      }

      // Update add button
      if (this.addButton) {
        this.addButton.disabled = !variant.available;
        this.addButton.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }

      // Update URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    },

    async handleSubmit(e) {
      e.preventDefault();
      
      const variantId = this.variantSelect.value;
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

      // Show loading state
      const originalText = this.addButton.textContent;
      this.addButton.disabled = true;
      this.addButton.innerHTML = '<span class="loading-spinner"></span> Adding...';

      await CartDrawer.addItem(variantId, quantity);

      // Reset button
      this.addButton.disabled = false;
      this.addButton.textContent = originalText;
    }
  };

  // ============================================
  // 3. PRODUCT IMAGE GALLERY
  // ============================================
  const ProductGallery = {
    mainImage: null,
    thumbnails: [],

    init() {
      this.mainImage = document.querySelector('.product-gallery-main img');
      this.thumbnails = document.querySelectorAll('.product-gallery-thumb');

      if (!this.mainImage || !this.thumbnails.length) return;

      this.thumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => this.selectImage(thumb));
      });
    },

    selectImage(thumb) {
      // Update active state
      this.thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      // Update main image
      const newSrc = thumb.querySelector('img').src;
      const newAlt = thumb.querySelector('img').alt;
      
      this.mainImage.style.opacity = '0';
      setTimeout(() => {
        this.mainImage.src = newSrc;
        this.mainImage.alt = newAlt;
        this.mainImage.style.opacity = '1';
      }, 150);
    }
  };

  // ============================================
  // 4. QUANTITY SELECTOR
  // ============================================
  const QuantitySelector = {
    init() {
      document.querySelectorAll('.product-quantity').forEach(container => {
        const input = container.querySelector('.product-quantity-input');
        const minusBtn = container.querySelector('[data-quantity-minus]');
        const plusBtn = container.querySelector('[data-quantity-plus]');

        if (!input) return;

        minusBtn?.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          if (currentValue > 1) {
            input.value = currentValue - 1;
            input.dispatchEvent(new Event('change'));
          }
        });

        plusBtn?.addEventListener('click', () => {
          const currentValue = parseInt(input.value) || 1;
          input.value = currentValue + 1;
          input.dispatchEvent(new Event('change'));
        });

        // Validate input
        input.addEventListener('change', () => {
          let value = parseInt(input.value) || 1;
          if (value < 1) value = 1;
          input.value = value;
        });
      });
    }
  };

  // ============================================
  // 5. MOBILE MENU
  // ============================================
  const MobileMenu = {
    button: null,
    menu: null,

    init() {
      this.button = document.querySelector('.mobile-menu-button');
      this.menu = document.querySelector('.mobile-menu');

      if (!this.button || !this.menu) return;

      this.button.addEventListener('click', () => this.toggle());

      // Close on link click
      this.menu.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', () => this.close());
      });
    },

    toggle() {
      this.menu.classList.toggle('open');
      this.button.setAttribute('aria-expanded', this.menu.classList.contains('open'));
    },

    close() {
      this.menu.classList.remove('open');
      this.button.setAttribute('aria-expanded', 'false');
    }
  };

  // ============================================
  // 6. ADD TO CART BUTTONS (Product Cards)
  // ============================================
  const AddToCartButtons = {
    init() {
      document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          
          const variantId = btn.dataset.variantId;
          if (!variantId) return;

          // Show loading state
          const originalText = btn.textContent;
          btn.disabled = true;
          btn.innerHTML = '<span class="loading-spinner"></span>';

          await CartDrawer.addItem(variantId);

          // Show success state briefly
          btn.innerHTML = '✓ Added';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = originalText;
          }, 1500);
        });
      });
    }
  };

  // ============================================
  // 7. SMOOTH SCROLL
  // ============================================
  const SmoothScroll = {
    init() {
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', (e) => {
          const href = anchor.getAttribute('href');
          if (href === '#') return;

          const target = document.querySelector(href);
          if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }
  };

  // ============================================
  // 8. INTERSECTION OBSERVER ANIMATIONS
  // ============================================
  const ScrollAnimations = {
    init() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });

      document.querySelectorAll('[data-animate]').forEach(el => {
        observer.observe(el);
      });
    }
  };

  // ============================================
  // INITIALIZATION
  // ============================================
  document.addEventListener('DOMContentLoaded', () => {
    CartDrawer.init();
    ProductVariants.init();
    ProductGallery.init();
    QuantitySelector.init();
    MobileMenu.init();
    AddToCartButtons.init();
    SmoothScroll.init();
    ScrollAnimations.init();
  });

  // Expose CartDrawer for external use
  window.LitterLove = {
    CartDrawer,
    ProductVariants,
    ProductGallery
  };

})();
